export const ALREADY_SHOWN_MISSING_DATA_MODAL_PREFIX =
  'alreadyShowMissingDataModal';

export const ALREADY_SHOWN_MISSING_DATA_MODAL_SESSION_PREFIX =
  'alreadyShowInSessionMissingDataModal';
